import * as REST from '~services/rest';

// Calls the note suggestion endpoint and returns the generated text.
// No auth token: this runs during intake, where the user may not be logged
// in yet (same as the location lookups on this flow). shouldThrowError lets
// the caller handle failures inline instead of triggering the global error
// prompt.
export const requestSuggestedNote = async (payload) => {
  const result = await REST.post({
    name: 'suggest-note',
    params: payload,
    mockFileName: 'suggest-note',
    shouldThrowError: true,
  });

  const note = result?.data?.note;
  if (!note) {
    throw new Error('Empty suggestion');
  }

  return note;
};
